import { apiCall } from './gqlClient';
const GETALLEMAILTEMPLATES_QUERY = "\n  query getAllEmailTemplates {\n    getAllEmailTemplates\n    {\n      id\n\t\t\tproviderId\n\t\t\tfileId\n\t\t\tthumbnailUrl\n\t\t\tfileName\n\t\t\tfileTitle\n\t\t\tname\n\t\t\theader\n\t\t\tcontent\n\t\t\tfooter\n\t\t\tcolor\n\t\t\tactive\n      ...fragments\n    }\n  }";
export const getAllEmailTemplatesApiCall = async function () {
  let fragments = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  return apiCall({
    query: GETALLEMAILTEMPLATES_QUERY,
    variables: {},
    fragments
  });
};
const SAVEEMAILTEMPLATE_QUERY = "\n  mutation saveEmailTemplate($template: EmailTemplateInput!) {\n    saveEmailTemplate(template: $template)\n    {\n      id\n\t\t\tcopyId\n\t\t\tpresignedUrl\n\t\t\tpresignedUrls\n\t\t\tsignedUrl\n\t\t\tsuccess\n\t\t\tname\n\t\t\tsectionIndex\n\t\t\ttype\n\t\t\tsignatureFileId\n      ...fragments\n    }\n  }";
export const saveEmailTemplateApiCall = async function (_ref) {
  let {
    template
  } = _ref;
  let fragments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return apiCall({
    query: SAVEEMAILTEMPLATE_QUERY,
    variables: {
      template
    },
    fragments
  });
};
const UPDATEEMAILTEMPLATE_QUERY = "\n  mutation updateEmailTemplate($id: String!, $template: EmailTemplateInput!) {\n    updateEmailTemplate(id: $id, template: $template)\n    {\n      success\n\t\t\tmessage\n\t\t\tid\n\t\t\tname\n\t\t\tidx\n\t\t\ttitle\n      ...fragments\n    }\n  }";
export const updateEmailTemplateApiCall = async function (_ref2) {
  let {
    id,
    template
  } = _ref2;
  let fragments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return apiCall({
    query: UPDATEEMAILTEMPLATE_QUERY,
    variables: {
      id,
      template
    },
    fragments
  });
};
const DELETEEMAILTEMPLATE_QUERY = "\n  mutation deleteEmailTemplate($id: String!, $active: Boolean!) {\n    deleteEmailTemplate(id: $id, active: $active)\n    {\n      success\n\t\t\tmessage\n\t\t\tid\n\t\t\tname\n\t\t\tidx\n\t\t\ttitle\n      ...fragments\n    }\n  }";
export const deleteEmailTemplateApiCall = async function (_ref3) {
  let {
    id,
    active
  } = _ref3;
  let fragments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return apiCall({
    query: DELETEEMAILTEMPLATE_QUERY,
    variables: {
      id,
      active
    },
    fragments
  });
};
const ACTIVATEEMAILTEMPLATE_QUERY = "\n  mutation activateEmailTemplate($id: String!, $color: String!, $logo: String!, $active: Boolean!) {\n    activateEmailTemplate(id: $id, color: $color, logo: $logo, active: $active)\n    {\n      success\n\t\t\tmessage\n\t\t\tid\n\t\t\tname\n\t\t\tidx\n\t\t\ttitle\n      ...fragments\n    }\n  }";
export const activateEmailTemplateApiCall = async function (_ref4) {
  let {
    id,
    color,
    logo,
    active
  } = _ref4;
  let fragments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return apiCall({
    query: ACTIVATEEMAILTEMPLATE_QUERY,
    variables: {
      id,
      color,
      logo,
      active
    },
    fragments
  });
};
const SENDTESTTEMPLATEMAIL_QUERY = "\n  mutation sendTestTemplateMail {\n    sendTestTemplateMail\n  }";
export const sendTestTemplateMailApiCall = async () => apiCall({
  query: SENDTESTTEMPLATEMAIL_QUERY,
  variables: {}
});